// /assets/scripts/events.js
import { EventBus } from './events/event-bus.js';

window.EventBus = EventBus;

(function () {
  if (!HTMLElement.prototype.on) {
    HTMLElement.prototype.on = function (eventName, callback) {
      if (eventName.includes('.')) return EventBus.on(eventName, callback);
      this.addEventListener(eventName, callback);
      return this;
    };
  }

  if (!HTMLElement.prototype.off) {
    HTMLElement.prototype.off = function (eventName, callback) {
      if (eventName.includes('.')) return EventBus.off(eventName, callback);
      this.removeEventListener(eventName, callback);
      return this;
    };
  }

  if (!HTMLElement.prototype.once) {
    HTMLElement.prototype.once = function (eventName, callback) {
      if (eventName.includes('.')) return EventBus.once(eventName, callback);
      const onceWrapper = (e) => {
        callback(e);
        this.removeEventListener(eventName, onceWrapper);
      };
      this.addEventListener(eventName, onceWrapper);
      return this;
    };
  }
})();

export { EventBus };
export default {};
